import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import Stack from '@mui/material/Stack';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Alert": Alert, "@mui/icons-material/Check": CheckIcon, "@mui/icons-material/CheckCircleOutlined": CheckCircleOutlineIcon, "@mui/material/Stack": Stack } } });
export default ClientProvider;
